import {StorageWrapper} from './StorageWrapper'

interface KeyBind {
    keyboardEventCode: string
    onTrigger: () => void
    isListening: () => boolean
    shortcutLocation: ShortcutLocation
    minWaitBetweenSameKeyPressInMilliseconds: number
    withShift: boolean
}

export enum ShortcutLocation {
    InGame = 0,
    InLobby = 1,
    General = 2,
}

export class KeyBindController {
    // TODO: abstract this to web
    private static _instance: KeyBindController
    private readonly onKeyDownListener: (keyboardEvent: KeyboardEvent) => void
    private keyBinds: KeyBind[] = []
    private lastUnixTimeEachKeyWasPressed: {[keyboardEventCode: string]: number} = {}
    private areKeyBindsEnabled: boolean

    private constructor() {
        this.onKeyDownListener = (keyboardEvent: KeyboardEvent) => this.onKeyDown(keyboardEvent.code, keyboardEvent.shiftKey)
        document.addEventListener('keydown', this.onKeyDownListener)
        this.areKeyBindsEnabled = true
    }

    static get instance(): KeyBindController {
        if(KeyBindController._instance == undefined) KeyBindController._instance = new KeyBindController()
        return KeyBindController._instance
    }

    static bindKey(keyboardEventCode: string, onTrigger: () => void, isListening: () => boolean, shortcutLocation: ShortcutLocation, withShift: boolean = false, minWaitBetweenSameKeyPressInMilliseconds: number = 500) {
        KeyBindController.instance.bindKey(keyboardEventCode, onTrigger, isListening, shortcutLocation, minWaitBetweenSameKeyPressInMilliseconds, withShift)
    }

    private onKeyDown(pressedKeyboardEventCode: string, pressedShiftKey: boolean) {
        if(isTypingInTextInput()) return
        if(!this.areKeyBindsEnabled) return
        const currentUnixTime: number = Date.now()
        for(const keyBind of this.keyBinds) {
            const {keyboardEventCode, onTrigger, isListening, shortcutLocation, withShift} = keyBind

            const shouldTriggerInGameShortcuts = StorageWrapper.getKeyboardShortcuts() === true
            if(shortcutLocation === ShortcutLocation.InGame && !shouldTriggerInGameShortcuts) continue

            if(keyboardEventCode != pressedKeyboardEventCode) continue
            if(withShift && !pressedShiftKey) continue
            if(pressedShiftKey && !withShift) continue

            if(isListening() == false) continue
            const millisecondSinceLastKeyPress = currentUnixTime - this.lastUnixTimeEachKeyWasPressed[keyboardEventCode]
            if((millisecondSinceLastKeyPress < keyBind.minWaitBetweenSameKeyPressInMilliseconds) && (millisecondSinceLastKeyPress != 0)) continue
            this.lastUnixTimeEachKeyWasPressed[pressedKeyboardEventCode] = currentUnixTime
            onTrigger()
        }
    }

    bindKey(keyboardEventCode: string, onTrigger: () => void, isListening: () => boolean, shortcutLocation: ShortcutLocation, minWaitBetweenSameKeyPressInMilliseconds: number, withShift: boolean = false) {
        const item: KeyBind = {
            keyboardEventCode: keyboardEventCode,
            onTrigger: onTrigger,
            isListening: isListening,
            shortcutLocation: shortcutLocation,
            minWaitBetweenSameKeyPressInMilliseconds: minWaitBetweenSameKeyPressInMilliseconds,
            withShift: withShift,
        }

        this.keyBinds.push(item)
    }

    clearAllKeyBinds() {
        this.keyBinds = []
    }

    disableKeyBindings() {
        this.areKeyBindsEnabled = false
    }

    enableKeyBindings() {
        this.areKeyBindsEnabled = true
    }
}

function isTypingInTextInput(): boolean {
    const activeElement = document.activeElement as HTMLInputElement
    if(activeElement.nodeName != 'INPUT') return false
    if(activeElement.type != 'text') return false
    return true
}
